import SlotsRepository from "./SlotsRepository"
import DiaryRepository from "./DiaryRepository"
import SettingsRepository from "./SettingsRepository"

const repositories = {
	slots: SlotsRepository,
	diary: DiaryRepository,
	settings: SettingsRepository
}

export const RepositoryFactory = {
	get: name => repositories[name],
	put: name => repositories[name],
	post: name => repositories[name],
	delete: name => repositories[name]
	};